import Main from "@/app/routes/main"
import Login from "@/app/routes/login"
import Onboarding from "@/app/routes/onboarding"
import { Navigate, createBrowserRouter } from "react-router-dom"

const router = createBrowserRouter([
  Main,
  Login,
  Onboarding,
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
])

export default router
